import React, { createContext, useContext } from "react";
import IAPI from "../../../models/IAPI";
import { IIntegrationAccessCollection } from "../../../models/IIntegrationAccessCollection";
import { useIntegration } from "../hooks/useIntegration";

interface IIntegrationContext {
  showRemoveAPIsDialog: boolean;
  setShowRemoveAPIsDialog: (val: boolean) => void;
  removeAPIsConfirmed: boolean;
  setRemoveAPIsConfirmed: (val: boolean) => void;
  apiToken: string;
  integrationCompanyId: number;
  integrationID: number;
  apis: IAPI[];
  setApis: (val: IAPI[]) => void;
  access: IIntegrationAccessCollection | undefined;
  setAccess: (val: IIntegrationAccessCollection | undefined) => void;
  showXMLFieldsDialog: boolean;
  setShowXMLFieldsDialog: (val: boolean) => void;
  showCustomAPIFieldsDialog: boolean;
  setShowCustomAPIFieldsDialog: (val: boolean) => void;
  showSubmitForProductionDialog: boolean;
  setShowSubmitForProductionDialog: (val: boolean) => void;
}

const IntegrationContext = createContext<IIntegrationContext | undefined>(undefined);

interface IIntegrationContextProviderProps {
  companyId: number;
  integrationId: number;
  token: string;
  children?: React.ReactNode;
}

const useIntegrationContext = () => {
  const integrationContext = useContext(IntegrationContext);
  if (!integrationContext) {
    throw new Error("No IntegrationContext Provider found when calling useIntegrationContext");
  }
  return integrationContext;
};

function IntegrationContextProvider(props: IIntegrationContextProviderProps) {
  const { children, companyId, integrationId: integrationId, token } = props;
  const {
    apiToken,
    integrationCompanyId: integrationCompanyId,
    integrationID: integrationID,
    showRemoveAPIsDialog,
    setShowRemoveAPIsDialog,
    removeAPIsConfirmed,
    setRemoveAPIsConfirmed,
    apis,
    setApis,
    access,
    setAccess,
    showXMLFieldsDialog,
    setShowXMLFieldsDialog,
    showCustomAPIFieldsDialog,
    setShowCustomAPIFieldsDialog,
    showSubmitForProductionDialog,
    setShowSubmitForProductionDialog,
  } = useIntegration(token, companyId, integrationId);

  return (
    <IntegrationContext.Provider
      value={{
        apiToken,
        integrationCompanyId: integrationCompanyId,
        integrationID: integrationID,
        showRemoveAPIsDialog,
        setShowRemoveAPIsDialog,
        removeAPIsConfirmed,
        setRemoveAPIsConfirmed,
        apis,
        setApis,
        access,
        setAccess,
        showXMLFieldsDialog,
        setShowXMLFieldsDialog,
        showCustomAPIFieldsDialog,
        setShowCustomAPIFieldsDialog,
        showSubmitForProductionDialog,
        setShowSubmitForProductionDialog,
      }}
    >
      {children}
    </IntegrationContext.Provider>
  );
}

export { useIntegrationContext, IntegrationContextProvider };
